export default "__VITE_ASSET__NkVdQi24__"